<div class="main_content px-3 position-relative">

    <div class="container-fluid py-3">
        <div class="title mb-4">
            <h3>My Galleries</h3>
        </div>
        <div class="my-2">
            <button class="btn btn-success" (click)="openModal(UploadFileModal)">
                <i class="fa-solid fa-plus"></i> Add Gallery
            </button>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 ">
                <div class="card shadow p-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 mb-3">
                                <div class="d-flex justify-content-end">
                                    <select class="form-control w-auto" [(ngModel)]="filterType"
                                        (change)="handleFilter()">
                                        <option value="popular">Popular</option>
                                        <option value="new">New</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4 mb-4" *ngFor="let item of galleries; let i = index;">
                                <div class="card h-100 position-relative">
                                    <img loading="lazy" [src]="imgUrl + item.file" class="card-img-top" alt="Gallery Image"
                                        style="width: 100%; height: 200px; object-fit: cover;">
                                    <div class="card-body">
                                        <p class="card-text">{{item.description || 'No description'}}</p>
                                        <p class="card-text"><i class="fa-solid fa-heart text-danger"></i>
                                            {{item.likes_total}}
                                        </p>
                                    </div>
                                    <button type="button" class="btn btn-danger position-absolute top-0 m-2"
                                        style="right: 0;" (click)="handleDelete(item.id)">
                                        <i class="fa-solid fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer bg-white border-0">
                        <div class="pagination-controls mt-4 d-flex justify-content-end">
                            <button class="btn btn-secondary" (click)="previousPage()" [disabled]="currentPage === 1">
                                Previous
                            </button>
                            <span class="mx-2">Page {{currentPage}} of {{totalPages}}</span>
                            <button class="btn btn-secondary" (click)="nextPage()"
                                [disabled]="currentPage === totalPages">
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #UploadFileModal let-modal>
    <div class="modal-content">
        <div class="card">
            <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                <h5 class="modal-title mb-0">Upload File</h5>
                <button type="button" class="btn-close btn-close-white" aria-label="Close"
                    (click)="modalService.dismissAll()"></button>
            </div>
            <div class="card-body">
                <p class="card-text">Please select a file to upload.</p>
                <div class="mb-3">
                    <input class="form-control" type="file" accept="image/*" (change)="onFileSelected($event)" />
                    <div *ngIf="thumbnail" class="thumbnail-preview mt-3">
                        <img loading="lazy" [src]="thumbnail" alt="Thumbnail Preview" class="img-thumbnail" />
                    </div>
                </div>
                <div class="mb-3">
                    <label for="description" class="form-label">Description</label>
                    <input type="text" class="form-control" id="description" [(ngModel)]="description"
                        placeholder="Enter description" />
                </div>
            </div>
            <div class="card-footer d-flex justify-content-end">
                <button type="button" class="btn btn-primary me-2" (click)="handleUpload()"
                    [disabled]="isUploading">Upload</button>
                <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()"
                    [disabled]="isUploading">Cancel</button>
            </div>
        </div>
    </div>
</ng-template>